import { render, staticRenderFns } from "./CascoAjanlatAdatokB6_V0.vue?vue&type=template&id=3b281ad3&"
import script from "./CascoAjanlatAdatokB6_V0.vue?vue&type=script&lang=js&"
export * from "./CascoAjanlatAdatokB6_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports